module.exports = __webpack_public_path__ + "img/thumbnail_DromedaryCamel_m_piebald.71da8509.png";